/**
 * Google Tag Manager Service
 * Contains functions for initialization and sending events to GTM
 */

// Initialize GTM script (optional - can be loaded directly in HTML)
export const initGTM = (gtmId) => {
  if (typeof window === 'undefined' || !gtmId) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js'
  });
};

// Send custom event to GTM
export const sendGTMEvent = (eventData) => {
  if (typeof window === 'undefined' || !window.dataLayer) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('GTM dataLayer is not initialized');
    }
    return;
  }

  window.dataLayer.push(eventData);
  if (process.env.NODE_ENV === 'development') {
    console.log('GTM Event:', eventData); // For debugging
  }
};

// Predefined event types for easier use

// Event for topic click
export const trackTopicClick = (topicName, topicPath) => {
  sendGTMEvent({
    event: 'topic_click',
    topic_name: topicName,
    topic_path: topicPath,
    timestamp: new Date().toISOString()
  });
};

// Event for page view
export const trackPageView = (pagePath, pageTitle) => {
  sendGTMEvent({
    event: 'page_view',
    page_path: pagePath,
    page_title: pageTitle,
    timestamp: new Date().toISOString()
  });
};

// Event for question interaction
export const trackQuestionInteraction = (questionId, action) => {
  sendGTMEvent({
    event: 'question_interaction',
    question_id: questionId,
    action: action, // 'view', 'expand', 'collapse', etc.
    timestamp: new Date().toISOString()
  });
};

// Event for user engagement
export const trackEngagement = (engagementType, details = {}) => {
  sendGTMEvent({
    event: 'user_engagement',
    engagement_type: engagementType,
    ...details,
    timestamp: new Date().toISOString()
  });
};

// Event for purchase/order click
export const trackPurchaseClick = (planName, planPrice, planLink) => {
  sendGTMEvent({
    event: 'purchase_click',
    plan_name: planName,
    plan_price: planPrice,
    plan_link: planLink,
    timestamp: new Date().toISOString()
  });
  
  // Also send to Facebook Pixel if available (e.g., fbq injected via GTM or directly)
  try {
    // Convert price like "$49" to number 49
    const numericPrice = parseFloat(String(planPrice).replace(/[^0-9.]/g, '')) || 0;
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', 'InitiateCheckout', {
        content_name: planName,
        value: numericPrice,
        currency: 'USD',
        content_url: planLink
      });
      if (process.env.NODE_ENV === 'development') {
        console.log('FB Pixel InitiateCheckout sent', { planName, numericPrice, planLink });
      }
    }
  } catch (err) {
    // don't break app if fbq isn't present or parsing fails
    if (process.env.NODE_ENV === 'development') {
      console.warn('Error sending FB Pixel event', err);
    }
  }
};

// Custom event (for whatever you need)
export const trackCustomEvent = (eventName, eventParams = {}) => {
  sendGTMEvent({
    event: eventName,
    ...eventParams,
    timestamp: new Date().toISOString()
  });
};
